import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import KuposCounter from './KuposCounter';

export class KuposAtCounter extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
  }

  render() {
    // console.log('Props in Kupos AT counter are----', this.props);
    return (
      <div className="common-kupos-at-counter">
        <div className="at-counter-row">
          <div className="at-icon-text">
            <div>
              <img
                className="at-count-user-type-icon"
                src={
                  this.props.kuposType === 'kupos_adult'
                    ? '/images/kupos-AirportTransfer-Icon-Adult.svg'
                    : this.props.kuposType === 'kupos_kid'
                    ? '/images/kupos-AirportTransfer-Icon-Kids.svg'
                    : this.props.kuposType === 'kupos_infant'
                    ? '/images/kupos-AirportTransfer-Icon-Infants.svg'
                    : null
                }
              />
            </div>
            <div>
              <div className="at-kupos-info font9">
                {/* <span>
                  {this.props.kuposType === 'kupos_adult'
                    ? this.props.seatInfo.name
                    : this.props.kuposType === 'kupos_kid'
                    ? this.props.seatInfo.name
                    : this.props.kuposType === 'kupos_infant'
                    ? this.props.seatInfo.name
                    : null}
                </span> */}
                <span>
                  {this.props.seatInfo && this.props.seatInfo.value
                    ? this.props.seatInfo.value
                    : this.props.kuposType === 'kupos_adult'
                    ? 'Adult'
                    : this.props.kuposType === 'kupos_kid'
                    ? 'Kid'
                    : this.props.kuposType === 'kupos_infant'
                    ? 'Infant'
                    : null}
                </span>
              </div>
              <div>
                <span className="at-count-age-text">
                  {/* {this.props.kuposType === 'kupos_adult'
                    ? this.props.seatInfo.meta_data
                    : this.props.kuposType === 'kupos_kid'
                    ? this.props.seatInfo.meta_data
                    : this.props.kuposType === 'kupos_infant'
                    ? this.props.seatInfo.meta_data
                    : null} */}
                  {this.props.seatInfo && this.props.seatInfo.meta_data
                    ? this.props.seatInfo.meta_data
                    : this.props.kuposType === 'kupos_adult'
                    ? 'adult-'
                    : this.props.kuposType === 'kupos_kid'
                    ? 'kid-'
                    : this.props.kuposType === 'kupos_infant'
                    ? 'infant-'
                    : null}
                </span>
              </div>
            </div>
          </div>
          <KuposCounter
            value={this.props.selectedKupos}
            // error={this.state.transferKuposError && this.state.transferKuposError ? true : false}
            // errorMessage={this.state.transferKuposError}
            onChange={val => this.props.onTransferChange(val, 'kupos_adult')}
            noBorder
          />
        </div>
        {this.props.borderBottom ? <div className="at-horizonatal-line"></div> : null}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KuposAtCounter);



// WEBPACK FOOTER //
// ./src/features/common/KuposAtCounter.js